import { useSearchParams } from 'react-router';

import { Skin } from '@sorare/core/src/__generated__/globalTypes';
import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage.ts';

const isSkin = (skin: string | undefined): skin is Skin => {
  return Object.values(Skin).includes(skin as Skin);
};

export const useGallerySearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get(SEARCH_PARAMS.QUERY) || '';
  const skin = searchParams.get('skin') || undefined;
  const typedSkin = isSkin(skin) ? skin : undefined;
  const [showAll, setShowAll] = useLocalStorage(
    'enableShowAllCardSlots',
    false
  );
  const updateParams = (updates: Record<string, string | undefined>) => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        Object.entries(updates).forEach(([key, value]) => {
          if (value) {
            next.set(key, value);
          } else {
            next.delete(key);
          }
        });
        return next;
      },
      { replace: true }
    );
  };

  return {
    search,
    skin: typedSkin,
    showAll,
    onSearchChange: (newSearch: string) => {
      updateParams({ [SEARCH_PARAMS.QUERY]: newSearch || undefined });
    },
    onSkinChange: (newSkin: Skin | undefined) => {
      updateParams({ skin: newSkin });
    },
    onShowAllChange: (newShowAll: boolean) => {
      setShowAll(newShowAll);
    },
  };
};
